import React, { useState } from "react";
import { Col, Container, FormGroup, Row, Card, CardImg, CardBody, CardText, Badge, Nav, NavItem, NavLink, TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Breadcrumb, BreadcrumbItem, Table } from "reactstrap";
import "assets/scss/website/app.scss";
import editImage from "assets/images/edit.png"
import deleteImage from "assets/images/delete.png"
import ProfileImage from "assets/images/profile_icon.png"
import classnames from "classnames"
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import ResaleService from "services/Website/ResaleService"
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import "../styles.scss"
import DeleteModal from "components/Common/DeleteModal"
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

const TableList = (props) => {
    const { resale } = props
    const resaleService = new ResaleService()
    const [deleteModal, setDeleteModal] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const { t } = useTranslation();
    const currency = useSelector(state => state.Auth?.currency)
    const deleteResaleHandler = () => {
        resaleService.remove(resale ?.id).then(response => {
            if (response && response.status === SuccessOk) {
                toast.success("Resale deleted successfully")
                props.deleteResaleHandler(resale ?.id)
            }
        })
    }
    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
             props.deleteResaleHandler(resale ?.id)
        }
    } 
    const editResaleHandler = () => {
        props.history.push(`edit-resale/${resale ?.id}`)
    }
    return (
<>
            <tr>
                <td className={classnames("", { "text-end": AuthData.lang === "ar" ,"text-start" :AuthData.lang !== "ar"  })}>
                    <p className="mb-1 resale-line">{resale ?.listing_id}</p>
                </td>
                <td className={classnames("", { "text-end": AuthData.lang === "ar" ,"text-start" :AuthData.lang !== "ar"  })}>
                    <p className="mb-0 resale-line">{resale ?.unit_type?.name[`${AuthData.lang}`] ? resale ?.unit_type?.name[`${AuthData.lang}`] : resale ?.unit_type?.name?.en} {t("in")} {resale ?.location ?.City[`${AuthData.lang}`] ? resale ?.location ?.City[`${AuthData.lang}`] :resale ?.location ?.City ?.en}</p>
                    {/* <p className="mb-0 resale-line">{resale ?.unit_type} {t("in")} {resale ?.location ?.City[`${AuthData.lang}`] ? resale ?.location ?.City[`${AuthData.lang}`] :resale ?.location ?.City ?.en}</p> */}
                    <p className="text-muted mb-0 resale-2line">{!!resale.size ? parseInt(resale.size).toFixed(0) : parseInt(resale.total_built_up_area).toFixed(0)} {t("sqm")} - {!!resale?.price ? toCurrency(resale ?.price) : toCurrency(resale?.payment_plan?.total_price)} {currency?.currency_code} </p>
                    <p className="text-muted resale-2line"> {t("Created at")}: {resale ?.created_at} </p>
                </td>
                <td className={classnames("", { "text-end": AuthData.lang === "ar" ,"text-start" :AuthData.lang !== "ar"  })}>{t(resale ?.status)}</td>
                <td className={classnames("", { "text-end": AuthData.lang === "ar" ,"text-start" :AuthData.lang !== "ar"  })}>
                    <button className="btn p-0 me-2"><img src={editImage} onClick={editResaleHandler} /></button>
                    <button className="btn p-0"><img src={deleteImage} onClick={()=>setDeleteModal(!deleteModal)} /></button>
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={resale.name[`${AuthData.lang}`]  ? resale.name[`${AuthData.lang}`]  :resale.name.en }
                deletedItem={{id:resale.id}}
                modelService={resaleService}
                onCloseModal={(action) => handleCloseModal(action)}
            />
 </>
    );
};


const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
      return formatter.format(number);
}
export default TableList;
